import Schema from 'AppReact/schema';

export default {
  timeValue: Schema('string', 'primitive-nullable', { defaultValue: null }),
  hour: Schema('string', 'primitive-nullable', { defaultValue: null }),
  minute: Schema('string', 'primitive-nullable', { defaultValue: null }),
  ampm: Schema('string', 'primitive-nullable', { defaultValue: 'am' }),
  minuteInputRef: Schema({}, 'object', { defaultValue: null }),
  hourInputRef: Schema({}, 'object', { defaultValue: null }),
}